import { AjaxClient } from "app/common/ajax";
import * as $ from "jquery";

export class BBCodeEditor {
    private ajaxClient: AjaxClient;
    private outerDiv: JQuery<HTMLElement>;
    private textarea: JQuery<HTMLTextAreaElement>;

    public constructor(id: string, ajaxClient: AjaxClient) {
        this.ajaxClient = ajaxClient;
        this.outerDiv = $('#' + id);
        this.textarea = $('#' + id + ' textarea');

        this.initializeButtons();
        this.initializePreview(id);
    }

    private initializeButtons() {
        this.outerDiv.find('.editor-buttons a').on('click', (evt) => {
            const el = $(evt.currentTarget);
            this.surround(el.data('before') as string, el.data('after') as string);
            this.textarea.focus();
            return false;
        });

        this.outerDiv.find('.editor-buttons select').on('change', (evt) => {
            const el = $(evt.currentTarget);
            const before = (el.data('before') as string).replace('$1', el.val() as string);
            const after = el.data('after') as string;
            this.surround(before, after);

            el.val(el.data('default') as string);
            this.textarea.focus();
            return false;
        });
    }

    private initializePreview(id: string) {
        const button = $(`.preview-button[data-editor-id=${id}]`);
        if (button == null) {
            return;
        }

        button.on('click', (evt): boolean => {
            const el = $(evt.currentTarget);
            const preview = $(`#${el.data('previewId') as string}`);

            void this.ajaxClient.call<string>('/api/forum/preview', { body: this.textarea.val() }).then(
                (result: string) => {
                    preview.html(`<div class="bbcode-preview">${result}</div>`)
                },
                (reason: string) => {
                    preview.html('<div class="bbcode-preview error">'
                        + `There was an error retrieving the post preview: ${reason}</div>`);
                }
            );

            return false;
        });
    }

    public insertQuote(content: string, username: string) {
        this.insertText(`[quote=${username}]${content}[/quote]\n`);
    }

    private insertText(content: string) {
        this.surround(content, '');
        this.textarea.focus();
    }

    private surround(before: string, after: string) {
        const start = this.textarea[0].selectionStart;
        const end = this.textarea[0].selectionEnd;
        const allText = this.textarea.val();

        const replaceBefore = before.split('\\n').join('\n');
        const replaceAfter = after.split('\\n').join('\n');

        this.textarea.val(
            allText.substring(0, start)
            + replaceBefore
            + allText.substring(start, end)
            + replaceAfter
            + allText.substring(end)
        );

        this.textarea[0].setSelectionRange(start + replaceBefore.length, end + replaceBefore.length);
    }
}
